module.exports = __webpack_public_path__ + "img/3-2.d85f22d9.png";